<template>
  <oxd-grid class="gsl-hrm-dashboard-card-grid" :cols="6">
    <oxd-grid-item>
      <dashboard-card
        v-if="leaveRequestCount > 0"
        icon="leave"
        :loading="isLoading"
        :title="$t('dashboard.pending_leave_request')"
        display-type="secondary"
        :sub-title="leaveRequestCount"
        @click="onClickPendingLeave"
      />
      <dashboard-card
        v-else
        icon="pim"
        :loading="isLoading"
        :title="$t('dashboard.total_current_employees')"
        display-type="secondary"
        :sub-title="currentEmployee"
        @click="onClickEmployeeList"
      />
    </oxd-grid-item>

    <oxd-grid-item>
      <dashboard-card
        icon="myinfo"
        :loading="isLoading"
        :title="$t('dashboard.online_employees')"
        display-type="success"
        :sub-title="activeEmployees"
        @click="onClickActiveEmployeeList"
      />
    </oxd-grid-item>
    <oxd-grid-item v-if="$can.read('dashboard_total_project_card_widget')">
      <dashboard-card
        v-if="employeeClaims > 0"
        icon="claim"
        :loading="isLoading"
        :title="$t('dashboard.employee_new_claims')"
        display-type="main"
        :sub-title="employeeClaims"
        @click="onClickEmployeeClaims"
      />
      <dashboard-card
        v-else
        icon="directory"
        :loading="isLoading"
        :title="$t('dashboard.total_projects')"
        display-type="main"
        :sub-title="totalProjects"
        @click="onClickProjectList"
      />
    </oxd-grid-item>
    <oxd-grid-item v-else>
      <dashboard-card
        icon="directory"
        :loading="isLoading"
        :title="$t('dashboard.allocated_projects')"
        display-type="main"
        :sub-title="myAllocatedProject"
        @click="onClickProjectAllocationList"
      />
    </oxd-grid-item>

    <oxd-grid-item>
      <dashboard-card
        v-if="$can.read('dashboard_timesheets_approve_card_widget')"
        icon="attendance"
        :loading="isLoading"
        :title="$t('dashboard.timesheets_to_approve')"
        display-type="warn"
        :sub-title="timeSheetCount"
        @click="onClickPendingTimesheet"
      />
      <dashboard-card
        v-else
        icon="attendance"
        :loading="isLoading"
        :title="$t('dashboard.total_leave_entitlement')"
        display-type="warn"
        :sub-title="myLeaveEntitlement"
        @click="onClickMyLeaveEntitlement"
      />
    </oxd-grid-item>
    <oxd-grid-item>
      <dashboard-card
        v-if="reviewCount > 0"
        icon="appraisals"
        :loading="isLoading"
        :title="$t('dashboard.performance_reviews')"
        display-type="danger"
        :sub-title="reviewCount"
        @click="onClickPendingReview"
      />
      <dashboard-card
        v-else
        icon="appraisals"
        :loading="isLoading"
        :title="$t('dashboard.pending_self_reviews')"
        display-type="danger"
        :sub-title="selfReviewCount"
        @click="onClickSelfReview"
      />
    </oxd-grid-item>
    <oxd-grid-item>
      <dashboard-card
        v-if="$can.read('dashboard_candidates_to_interview_card_widget')"
        icon="interview"
        :loading="isLoading"
        :title="$t('dashboard.candidates_to_interview')"
        display-type="info"
        :sub-title="interviewCount"
        @click="onClickPendingInterview"
      />
      <dashboard-card
        v-else
        icon="leave"
        :loading="isLoading"
        :title="$t('dashboard.scheduled_leaves')"
        display-type="info"
        :sub-title="myScheduledLeave"
        @click="onClickMyScheduledLeave"
      />
    </oxd-grid-item>
  </oxd-grid>
</template>
<script>
import DashboardCard from '@/orangehrmDashboardPlugin/components/DashboardCard.vue';
import {APIService} from '@/core/util/services/api.service';
import {navigate} from '@ohrm/core/util/helper/navigation';

export default {
  name: 'QuickInformationCards',
  components: {
    'dashboard-card': DashboardCard,
  },
  props: {
    empNumber: {
      type: [String, Number],
      required: true,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/dashboard/employees/action-summary',
    );

    return {
      http,
    };
  },
  data() {
    return {
      isLoading: false,
      myActions: [],
      leaveRequestCount: 0,
      timeSheetCount: 0,
      reviewCount: 0,
      selfReviewCount: 0,
      interviewCount: 0,
      currentEmployee: 0,
      totalProjects: 0,
      activeEmployees: 0,
      myLeaveEntitlement: 0,
      myAllocatedProject: 0,
      myScheduledLeave: 0,
      employeeClaims: 0,
    };
  },
  beforeMount() {
    this.isLoading = true;
    this.http
      .getAll()
      .then((response) => {
        const {data} = response.data;
        this.myActions = data.map((item) => {
          const {group, pendingActionCount} = item;
          if (group === 'Leave Requests To Approve') {
            this.leaveRequestCount = pendingActionCount;
          }
          if (group === 'Timesheets To Approve') {
            this.timeSheetCount = pendingActionCount;
          }
          if (group === 'Pending Appraisal Reviews') {
            this.reviewCount = pendingActionCount;
          }
          if (group === 'Pending Self Reviews') {
            this.selfReviewCount = pendingActionCount;
          }
          if (group === 'Candidates To Interview') {
            this.interviewCount = pendingActionCount;
          }
          if (group === 'Current Employees') {
            this.currentEmployee = pendingActionCount;
          }
          if (group === 'Total Projects') {
            this.totalProjects = pendingActionCount;
          }
          if (group === 'Active Employees') {
            this.activeEmployees = pendingActionCount;
          }
          if (group === 'My Leave Entitlement') {
            this.myLeaveEntitlement = pendingActionCount;
          }
          if (group === 'My Allocated Project') {
            this.myAllocatedProject = pendingActionCount;
          }
          if (group === 'My Scheduled Leave') {
            this.myScheduledLeave = pendingActionCount;
          }
          if (group === 'Employee Claims') {
            this.employeeClaims = pendingActionCount;
          }
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onClickPendingLeave() {
      navigate('/leave/viewLeaveList');
    },
    onClickPendingTimesheet() {
      navigate('/time/viewEmployeeTimesheet');
    },
    onClickPendingReview() {
      navigate('/performance/searchEvaluatePerformanceReview');
    },
    onClickPendingInterview() {
      navigate('/recruitment/viewCandidates', undefined, {
        statusId: 4,
      });
    },
    onClickSelfReview() {
      navigate('/performance/myPerformanceReview');
    },
    onClickEmployeeList() {
      navigate('/pim/viewEmployeeList');
    },
    onClickProjectList() {
      navigate('/time/viewProjects');
    },
    onClickActiveEmployeeList() {
      navigate('/attendance/viewAttendanceRecord');
    },
    onClickMyLeaveEntitlement() {
      navigate('/leave/viewMyLeaveEntitlements');
    },
    onClickProjectAllocationList() {
      navigate(`/pim/viewProjectDetails/empNumber/${this.empNumber}`);
    },
    onClickMyScheduledLeave() {
      navigate('/leave/viewMyLeaveList');
    },
    onClickEmployeeClaims() {
      navigate('/claim/viewAssignClaim');
    },
  },
};
</script>
<style lang="scss" scoped>
.gsl-hrm-dashboard-card-grid {
  margin: 0 auto;
  margin-top: 20px;
  box-sizing: border-box;

  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1100px) {
    // Medium screens: 3 cards per row
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1700px) {
    // Large screens: 6 cards per row
    grid-template-columns: repeat(6, 1fr);
  }
}
</style>
